export default __webpack_public_path__ + "static/media/Blacksulphur Robe.a7bfb5f2.jpg";